import { render, staticRenderFns } from "./InvoiceTypeField.vue?vue&type=template&id=481bfb58"
import script from "./InvoiceTypeField.vue?vue&type=script&lang=js"
export * from "./InvoiceTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports